import { useParams } from "react-router";
import { authEmployeeSocketApiConnectionHelper, makeNoAuthApiRequest, makeTenantAuthApiRequest, makeTenantNoAuthApiRequest } from "../api/api_helper";
import { success_auth_sign_out } from "../reducers/auth_tenant/auth_sign_out_Slice";
import axios from "axios";
import { fetchImageAsBase64 } from "../utils/Utils";
import { reset_announcements_update, success_announcements_update } from "../reducers/auth_tenant/announcements_update_Slice";

const tenant_url_prefix = window.location.pathname.split("/")[1] || "";

// const API_URL = "http://localhost:4000/api/v1/";
// const API_URL = "https://dev-katundu360-api.afrocentec.com/api/v1/"; //dev
const API_URL = "https://katundu360-api.afrocentec.com/api/v1/"; //Prod

export const no_tenant_actions_helper =
  (loadingState, successState, failState, errorMessage, successMessage, apiReqType, apiEndpoint, formData = null) =>
    async (dispatch) => {
      try
      {
        //Set Loading
        dispatch(loadingState());
        //Making API Request
        const { data } = await makeNoAuthApiRequest(apiReqType, apiEndpoint, formData);
        // if (data.message === successMessage)
        // {
        dispatch(successState(data.data));
        // }
      } catch (error)
      {
        console.log(error);
        // Server or Network Error
        if (error.code === "ERR_NETWORK" || error.code === "ERR_BAD_RESPONSE")
        {
          dispatch(failState(errorMessage));
        } else
        {
          // Bad Response Message
          if (error.response.status === 400)
          {
            dispatch(failState(error.response.data.message));
          }
          else if (error.response.status === 401)
          {
            dispatch(failState(error.response.data.message));
          }
          else
          {
            dispatch(failState(errorMessage));
          }
        }
      }
    };

export const tenant_no_auth_actions_helper =
  (loadingState, successState, failState, errorMessage, successMessage, apiReqType, apiEndpoint, formData = null) =>
    async (dispatch) => {
      try
      {
        //Set Loading
        dispatch(loadingState());
        //Making API Request
        const { data } = await makeTenantNoAuthApiRequest(apiReqType, apiEndpoint, formData);
        // if (data.message === successMessage)
        // {
        dispatch(successState(data.data));
        // }
      } catch (error)
      {
        console.log(error);
        // Server or Network Error
        if (error.code === "ERR_NETWORK" || error.code === "ERR_BAD_RESPONSE")
        {
          dispatch(failState(errorMessage));
        } else
        {
          // Bad Response Message
          if (error?.response?.status === 400)
          {
            dispatch(failState(error?.response.data.message));
          }
          else if (error?.response?.status === 401)
          {
            if (error?.response?.data.message?.trim() === "Unauthenticated. Invalid Token")
            {
              try
              {
                const response = await axios.get(`${API_URL}${tenant_url_prefix}`);
                // Set Logo
                const tenant_data = { ...response.data?.data?.tenant_data?.tenant, ["tenant_logo"]: await fetchImageAsBase64(response.data?.data?.tenant_data?.tenant?.tenant_logo) };

                localStorage.setItem('dashboard_tenant', JSON.stringify(tenant_data));
                localStorage.setItem('dashboard_access', JSON.stringify(response.data?.data?.token));
                // Make the Request after 2000 ms
                setTimeout(() => {
                  // Your code to run after 1500 milliseconds (Because of Localstorage Setup)
                  dispatch(tenant_no_auth_actions_helper(loadingState, successState, failState, errorMessage, successMessage, apiReqType, apiEndpoint, formData));
                }, 2000);

              } catch (refreshError)
              {
                console.error("Token refresh failed:", refreshError);
              }
            }
            else
            {
              dispatch(failState(error?.response?.data.message));
            }
          }
          else
          {
            dispatch(failState(errorMessage));
          }
        }
      }
    };

export const tenant_auth_actions_helper =
  (loadingState, successState, failState, errorMessage, successMessage, apiReqType, apiEndpoint, formData = null) =>
    async (dispatch) => {
      try
      {
        //Set Loading
        dispatch(loadingState());
        //Making API Request
        const { data } = await makeTenantAuthApiRequest(apiReqType, apiEndpoint, formData);
        // if (data.message === successMessage)
        // {
        if (data.data)
        {
          dispatch(successState(data.data));
        }
        else
        {
          dispatch(successState(data));
        }
        // }
      } catch (error)
      {
        console.log(error);
        // Server or Network Error
        if (error.code === "ERR_NETWORK" || error.code === "ERR_BAD_RESPONSE")
        {
          dispatch(failState(errorMessage));
        } else
        {
          // Bad Response Message
          if (error?.response?.status === 400)
          {
            dispatch(failState(error?.response.data.message));
          }
          else if (error?.response?.status === 401)
          {
            console.log(error?.response?.data.message);
            if (error?.response?.data.message?.trim() === "Unauthenticated.")
            {

              dispatch(failState(error?.response?.data.message));
              dispatch(success_auth_sign_out({ loadingState: loadingState, successState: successState, failState: failState, errorMessage: errorMessage, successMessage: successMessage, apiReqType: apiReqType, apiEndpoint: apiEndpoint, formData: formData }));
            }
            else if (error?.response?.data.message?.trim() === "Unauthenticated. Invalid Token")
            {
              try
              {
                const response = await axios.get(`${API_URL}${tenant_url_prefix}`);
                // Set Logo
                const tenant_data = { ...response.data?.data?.tenant, ["tenant_logo"]: await fetchImageAsBase64(response.data?.data?.tenant?.tenant_logo) };

                localStorage.setItem('dashboard_tenant', JSON.stringify(tenant_data));
                localStorage.setItem('dashboard_access', JSON.stringify(response.data?.data?.token));
                // Make the Request after 2000 ms
                setTimeout(() => {
                  // Your code to run after 1500 milliseconds (Because of Localstorage Setup)
                  dispatch(tenant_no_auth_actions_helper(loadingState, successState, failState, errorMessage, successMessage, apiReqType, apiEndpoint, formData));
                }, 2000);

              } catch (refreshError)
              {
                console.error("Token refresh failed:", refreshError);
              }
            }
            else
            {
              dispatch(failState(error?.response?.data.message));
            }
          }
          else
          {
            dispatch(failState(errorMessage));
          }
        }
      }
    };



// Channels Action Helpers
export const employee_channel_actions_helper =
  (connection) =>
    async (dispatch) => {
      try
      {
        if (!connection)
        {
          console.warn("⚠️ No socket connection provided.");
          return null;
        }

        console.log("I am here");
        // Retrieve Socket Connection
        // const socket_connection = await authEmployeeSocketApiConnectionHelper();

        // if (!socket_connection)
        // {
        //   console.warn("⚠️ Socket Not Available.");
        //   return null;
        // }

        // // Announcements Data Chanel
        // const announcements_channel = socket_connection?.channel("room:announcements", {});


        // // Join Channel
        // announcements_channel
        //   .join()
        //   .receive("ok", (resp) => {
        //     console.log("✅ Joined successfully", resp);

        //     // ⬇️ Run the listener inside "ok"
        //     announcements_channel.on("announcements", (payload) => {
        //       dispatch(success_announcements_update(payload));
        //     });
        //   })
        //   .receive("error", (resp) => {
        //     dispatch(reset_announcements_update());
        //     console.error("❌ Unable to join", resp);
        //   });

      } catch (err)
      {
        console.error("❌ Socket connection error:", err);
        dispatch({ type: "SOCKET_ERROR", payload: err.message });
        return null;
      }
    };